"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assignment = assignment;
exports.buildUrL = buildUrL;
exports.debounce = debounce;
exports.getDateByDay = getDateByDay;
exports.handleScrollHeader = handleScrollHeader;
exports.inArray = inArray;
exports.isArray = isArray;
exports.isEmpty = isEmpty;
exports.isEmptyObject = isEmptyObject;
exports.isIE = isIE;
exports.isObject = isObject;
exports.removeLoadingAnimate = removeLoadingAnimate;
exports.throttle = throttle;
exports.timeFix = timeFix;
exports.triggerWindowResizeEvent = triggerWindowResizeEvent;
exports.urlEncode = void 0;
exports.welcome = welcome;
exports.zeroFillLeft = zeroFillLeft;
function timeFix() {
  var time = new Date();
  var hour = time.getHours();
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好';
}
function welcome() {
  var arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了'];
  var index = Math.floor(Math.random() * arr.length);
  return arr[index];
}

/**
 * 触发 window.resize
 */
function triggerWindowResizeEvent() {
  var event = document.createEvent('HTMLEvents');
  event.initEvent('resize', true, true);
  event.eventType = 'message';
  window.dispatchEvent(event);
}
function handleScrollHeader(callback) {
  var timer = 0;
  var beforeScrollTop = window.pageYOffset;
  callback = callback || function () {};
  window.addEventListener('scroll', function (event) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var direction = 'up';
      var afterScrollTop = window.pageYOffset;
      var delta = afterScrollTop - beforeScrollTop;
      if (delta === 0) {
        return false;
      }
      direction = delta > 0 ? 'down' : 'up';
      callback(direction);
      beforeScrollTop = afterScrollTop;
    }, 50);
  }, false);
}
function isIE() {
  var bw = window.navigator.userAgent;
  var compare = function compare(s) {
    return bw.indexOf(s) >= 0;
  };
  var ie11 = function () {
    return 'ActiveXObject' in window;
  }();
  return compare('MSIE') || ie11;
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
function removeLoadingAnimate() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1500;
  if (id === '') {
    return;
  }
  setTimeout(function () {
    document.body.removeChild(document.getElementById(id));
  }, timeout);
}

// 节流
// 思路： 第一次先设定一个变量true，
// 第二次执行这个函数时，会判断变量是否true，
// 是则返回。当第一次的定时器执行完函数最后会设定变量为flase。
// 那么下次判断变量时则为flase，函数会依次运行。
function throttle(fn) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  // 首先设定一个变量，在没有执行我们的定时器时为null
  var timer = null;
  return function () {
    var _arguments = arguments,
      _this = this;
    // 当我们发现这个定时器存在时，则表示定时器已经在运行中，需要返回
    if (timer) return;
    timer = setTimeout(function () {
      fn.apply(_this, _arguments);
      timer = null;
    }, delay);
  };
}

// 防抖
// 首次运行时把定时器赋值给一个变量， 第二次执行时，
// 如果间隔没超过定时器设定的时间则会清除掉定时器，
// 重新设定定时器， 依次反复， 当我们停止下来时，
// 没有执行清除定时器， 超过一定时间后触发回调函数。
function debounce(fun, delay) {
  return function (args) {
    // 获取函数的作用域和变量
    var that = this;
    var _args = args;
    // 每次事件被触发，都会清除当前的timeer，然后重写设置超时调用
    clearTimeout(fun.id);
    fun.id = setTimeout(function () {
      fun.call(that, _args);
    }, delay);
  };
}

/**
 * 判断是否为空对象
 * @param {*} object 源对象
 */
function isEmptyObject(object) {
  return Object.keys(object).length === 0;
}

/**
 * 判断是否为对象
 * @param {*} object
 */
function isObject(object) {
  return Object.prototype.toString.call(object) === '[object Object]';
}

/**
 * 判断是否为对象
 * @param {*} array
 */
function isArray(array) {
  return Object.prototype.toString.call(array) === '[object Array]';
}

/**
 * 判断是否为空
 * @param {*} object 源对象
 */
function isEmpty(value) {
  if (isArray(value)) {
    return value.length === 0;
  }
  if (isObject(value)) {
    return isEmptyObject(value);
  }
  return !value;
}

/**
 * 判断是否在数组中
 * @param {*} search
 * @param {*} array
 */
function inArray(search, array) {
  return array.includes(search);
}

/**
 * 获取指定天数的日期
 * @param day
 * @returns {string}
 */
function getDateByDay(day) {
  var today = new Date();
  var targetdaySeconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
  today.setTime(targetdaySeconds); // 注意，这行是关键代码
  return today.getFullYear() + '-' + zeroFillLeft(today.getMonth() + 1) + '-' + zeroFillLeft(today.getDate());
}

/**
 * 左侧补0
 * @param value
 * @returns {*}
 */
function zeroFillLeft(value) {
  return value.toString().length === 1 ? '0' + value : value;
}

/**
 * 批量给指定对象赋值
 * @param obj obj 指定的对象,一般为vue实例
 * @param obj assignment 赋值的元素 { a: '123' }
 */
function assignment(obj, assignment) {
  Object.keys(assignment).forEach(function (key) {
    obj[key] = assignment[key];
  });
}

/**
 * 对象转URL
 * @param {object} obj
 */
var urlEncode = exports.urlEncode = function urlEncode() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var result = [];
  var _loop = function _loop(key) {
    var item = obj[key];
    if (!item) {
      return 1; // continue
    }
    if (isArray(item)) {
      item.forEach(function (val) {
        result.push(key + '=' + val);
      });
    } else {
      result.push(key + '=' + item);
    }
  };
  for (var key in obj) {
    if (_loop(key)) continue;
  }
  return result.join('&');
};

/**
 * 生成url (带参数)
 * @param {string} path 链接
 * @param {object} params query参数
 */
function buildUrL(path, params) {
  var queryStr = urlEncode(params);
  if (!isEmpty(queryStr)) {
    return path + '?' + queryStr;
  }
  return path;
}